exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-isco[data-v-2dcf10d1], .btn-isco-reset[data-v-2dcf10d1] {\n  margin-top: 0;\n}\n.btn-isco[data-v-2dcf10d1] {\n  margin-right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-2dcf10d1","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/ProfilesSelector.vue
// module id = DuYC
// module chunks = 97